module.exports = __webpack_public_path__ + "../resources/images/illustration_attachment-d32e2f293da3785391267cc7fe61b4ee.svg";